
        Component.define('youbuy-internal', (el, params) => {
            /**
 * Each component receives the variables explained below
 *
 * @param {HTMLElement} el - Component's main DOM element
 * @param {Object} params - Params to be used
 */

const $el       = $(el);
const $tabLink  = $el.find('a[data-tab]');
const $shareBtn = $el.find('.share-btn');
const $btnShare = $el.find('.btn-share');
const $popShare = $el.find('.pop-share');

$('.slider-galery').slick({
  dots: true,
  slidesPerRow: 5,
  rows: 2,
});

$tabLink.on('click', function() {
    const $this = $(this);

    $el.find('.tab').add($tabLink).removeClass('active');
    $el.find('.tab[data-tab="' + $this.data('tab') + '"]').add($this).addClass('active');
});

$btnShare.on('mouseenter', function() {
    $popShare.addClass('active');
}).on('mouseleave', function() {
    // $popShare.hide();
});

$popShare.on('mouseleave', function() {
    $popShare.removeClass('active');
});

$shareBtn.on('click', function() {
    const $this = $(this);

    const URI   = root + 'youbuy/airplane/' + $this.data('id');
    const type  = $this.data('type');
    const desc  = 'Veja essa aeronave: ';
    const title = 'Youbuy';

    if (type == 'whatsapp') {
        Share.whatsapp(URI);
    } else if (type == 'facebook') {
        Share.facebook(URI);
    } else if (type == 'twitter') {
        Share.twitter(URI, desc);
    } else if (type == 'linkedin') {
        Share.linkedin(URI, title, desc);
    } else if (type == 'envie') {
        $('[data-component="share-modal"]').trigger('modal:open');
    }
});

        });